import React from "react";
import HomeCardComponent from "../components/homeCard/HomeCardComponent";
/**
 *
 * @returns JSX.Element
 *
 * Home page
 */
const Home: () => JSX.Element = () => {
  return (
    <>
      <HomeCardComponent />
    </>
  );
};

export default Home;
